import { useCallback, useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getCustomerNotifications } from "../../../redux/api/admin.api";
import { getClients } from "../../../redux/api/expedition.api";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import TableWidget from "../../../components/tables/TableWidget";
import CustomerNotificationsHeader from "./components/CustomerNotificationsHeader";

import {
  customerNotificationsTableHeader,
  getCustomerNotificationsTableData,
} from "./components/tableConfigs/customerNotificationsTableConfig";

function CustomerNotifications() {
  const dispatch = useAppDispatch();

  const {
    admin: {
      customerNotifications: {
        data: { total, data: customerNotificationsData },
        isLoading,
      },
    },
    expedition: {
      clients: { data: clientsData },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(getClients({ page: 1, perPage: 99999 }));
  }, [dispatch]);

  const getCustomerNotificationTableHeaderNew = useCallback(
    (initialTableData: any[]) => {
      return initialTableData.map((item) => {
        if (item.value === "client") {
          const clientsDropdown = clientsData?.data.map(
            ({ denumireClient, idClient }) => ({
              label: denumireClient,
              value: idClient || 0,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...clientsDropdown],
            ...item,
          };
        }

        return item;
      });
    },
    [clientsData?.data],
  );

  const handleTableActions = (action: TableActions) => {
    dispatch(
      getCustomerNotifications({
        page: action.tablePagination.page,
        perPage: action.tablePagination.rowsPerPage,
        id_client: action.tableSearch?.client,
        adresa: action.tableSearch?.adresa,
      }),
    );
  };

  const customerNotificationTableHeaderNew = useMemo(
    () =>
      getCustomerNotificationTableHeaderNew(customerNotificationsTableHeader),
    [getCustomerNotificationTableHeaderNew],
  );

  return (
    <TableWidget
      CustomHeaderComponent={CustomerNotificationsHeader}
      tableHeaderData={customerNotificationTableHeaderNew}
      tableItemsData={getCustomerNotificationsTableData(
        customerNotificationsData,
      )}
      totalItems={total}
      tableLoading={isLoading}
      handleTableActions={handleTableActions}
    />
  );
}

export default CustomerNotifications;
